import React from "react";
import { Outlet } from "react-router-dom";
import { ScrollProvider } from "Utils/ScrollContext";

function Layout() {
  return (
    <main className="main-wrapper">
      <ScrollProvider>
        <Outlet />
      </ScrollProvider>
    </main>
  );
}

export default Layout;
